//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { IsField, BindsAttrs } from '@/mixins'

export default {
  mixins: [
    IsField,
    BindsAttrs,
  ],
  props: {
    topLabel: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      localValue: false,
    }
  },
  watch: {
    value: {
      handler (value) {
        this.localValue = value
        if (!this.localValue) { this.localValue = false }
      },
      immediate: true
    }
  },
  methods: {
    change () {
      if (this.localValue) {
        this.$emit('input', this.localValue)
      } else {
        // for some reason it is emitting null not false
        this.$emit('input', false)
      }
    },
  }
}
